import {useQueries} from "@tanstack/react-query";
import individualService from "../../../../services/web/individual-service.js";
import natureService from "../../../../services/web/nature-service.js";

const useIndividualCatalogs = () => {
    const queries = useQueries({
        queries: [
            {queryKey: ["individual-colors"], queryFn: () => individualService.individualColors()},
            {queryKey: ["bodyShape"], queryFn: () => individualService.bodyShape()},
            {queryKey: ["colorEyes"], queryFn: () => individualService.colorEyes()},
            {queryKey: ["hairType"], queryFn: () => individualService.hairType()},
            {queryKey: ["hairColor"], queryFn: () => individualService.hairColor()},
            {queryKey: ["hairSize"], queryFn: () => individualService.hairSize()},
            {queryKey: ["situations"], queryFn: () => individualService.situations()},
            {queryKey: ["individual-instructions"], queryFn: () => individualService.individualInstructions()},
            {queryKey: ["individualRegion"], queryFn: () => individualService.region()},
            {queryKey: ["individualRegionDetail"], queryFn: () => individualService.regionDetail()},
            {queryKey: ["system_natures"], queryFn: () => natureService.getSystemNatures()},
            {queryKey: ["phone-providers"], queryFn: () => individualService.phoneProviders()},
        ],
    });

    return {
        individualColors: queries[0].data ?? [],
        bodyShapes: queries[1].data ?? [],
        eyeColors: queries[2].data ?? [],
        hairTypes: queries[3].data ?? [],
        hairColors: queries[4].data ?? [],
        hairSizes: queries[5].data ?? [],
        situations: queries[6].data ?? [],
        educationDegrees: queries[7].data ?? [],
        individualRegions: queries[8].data ?? [],
        individualRegionDetails: queries[9].data ?? [],
        systemNatures: queries[10].data ?? [],
        phoneProviders: queries[11].data ?? [],
    };
};

export default useIndividualCatalogs;
